import './navMenu.scss';
import { useContext, useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AccountContext } from '../../App';
import PersonOutline from '../../assets/images/IcnUser.svg';
import useAuth from '../../hooks/useAuth';

function NavMenu() {
    const { t } = useTranslation(['navMenu']); // i18n
    const { auth, logout } = useAuth();

    console.log(auth);

    const [secondNavIndex, setSecondNavIndex] = useState(null);
    const [listShow, setListShow] = useState(false);
    const [rwdNavShow, setRwdNavShow] = useState(false);
    const [userFullname, setUserFullname] = useState('');

    // fullname
    const accountContext = useContext(AccountContext);
    const { homePageIndex } = accountContext;

    // 多國語言
    const language = accountContext.lang;
    const { setLang } = accountContext;

    const navigate = useNavigate();
    const location = useLocation();
    const params = location.pathname;

    // NavMenu.js
    const handleIsLogin = () => {
        if (!auth?.accessToken) {
            setRwdNavShow(false);
            // return navigate('/login');
            logout();
        } else return;
    };

    // 捲動頁面改變nav背景顏色
    // scrolling可以用來判斷卷軸向上或向下，目前未使用因此註解
    const [scrolling, setScrolling] = useState(false);
    const [scrollTop, setScrollTop] = useState(0);

    useEffect(() => {
        // scroll
        const onScroll = (e) => {
            setScrollTop(e.target.documentElement.scrollTop);
            setScrolling(e.target.documentElement.scrollTop > scrollTop);
        };
        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, [scrollTop, params, homePageIndex, scrolling]);

    // 個人相關頁面-顯示名稱
    useEffect(() => {
        auth?.user?.fullname ? setUserFullname(auth?.user?.fullname) : setUserFullname('');
    }, [auth]);

    // 登出
    function handleLogout() {
        return logout();
    }

    return (
        <div className="container-fluid p-0 " id="nav-app">
            {/* navbar */}
            <header
                id="header-app"
                className="w-100 position-fixed top-0 px-5 bg-white border-bottom border-grey4 rwdNavBg"
            >
                <div className="h-100 d-flex align-items-center mx-auto" id="container-header">
                    {/* navbar left */}
                    {/* 1.logo */}
                    <div
                        className="head-logo"
                        // 關閉RwdNav
                        onClick={() => setRwdNavShow(false)}
                    >
                        <Link className="" to="/">
                            <img src="./images/pingtexLogo.png" alt="logo" />
                        </Link>
                    </div>

                    {/* 1.rwd hamburger button */}
                    <div
                        className="control-nav d-xl-none"
                        onClick={() => {
                            handleToggleNavList();
                        }}
                    >
                        <div className="mb-4 mb-xl-0" style={{ color: 'white' }} />
                        {/* {rwdNavShow ? (
							<Close className='mb-4 mb-xl-0' />
						) : homePageIndex === 2 || params !== '/' ? (
							<Menu
								className='mb-4 mb-xl-0'
								style={{ color: 'black' }}
							/>
						) : (
							<Menu
								className='mb-4 mb-xl-0'
								style={{ color: 'white' }}
							/>
						)} */}
                    </div>

                    {/* navbar center */}
                    {/* 2.head-menu */}

                    {/* navbar right */}
                    <nav className="head-right d-flex ms-auto">
                        <ul className="d-flex align-items-center list-unstyled m-0">
                            {/* 使用者資訊 */}
                            {auth?.accessToken ? (
                                <li
                                    role="button"
                                    id="personIconContainer"
                                    className=" position-relative px-2 pointer"
                                    onClick={handleLogout}
                                >
                                    登出
                                </li>
                            ) : (
                                <li
                                    role="button"
                                    id="personIconContainer"
                                    className=" position-relative px-2"
                                    onClick={() => navigate('/login')}
                                >
                                    登入
                                </li>
                            )}
                        </ul>
                    </nav>
                </div>
            </header>

            <div className="head-menu-second-bg position-fixed w-100 bg-white d-none" />

            {/* rwd navbar */}
            <div
                className={`rwd-navbar position-fixed ${rwdNavShow ? 'rwd-navbar-transition' : ''}`}
            >
                <div className="rwd-wrapper">
                    <div className={window.location.pathname === '/' ? 'rwd-nav-pages' : ''} />

                    <div className="rwd-nav-appDownload-btn px-3 mb-4">
                        <Link to="/app/download" onClick={() => setRwdNavShow(false)}>
                            <div className="btn rounded-pill px-3 px-xl-4 ">
                                {t('navMenu:appDownload')}
                            </div>
                        </Link>
                    </div>

                    <ul className="rwd-nav-lang m-0 border-top mx-3 ps-0  py-3">
                        <li className="d-flex align-items-center lang-box ">
                            {/* <Public /> */}
                            <select
                                className="ps-1"
                                id="language"
                                value={language || ''}
                                onChange={(e) => {
                                    localStorage.setItem('i18n', e.target.value);
                                    setLang(e.target.value);
                                }}
                            >
                                {/* <option value="zh-CN">简体中文</option> */}
                                <option value="zh-TW">繁體中文</option>
                                <option value="en">English</option>
                            </select>
                        </li>
                    </ul>

                    {auth?.accessToken ? (
                        <div className="rwd-nav-footer-login d-flex align-items-center border-top mx-3 py-3">
                            {/* <PersonOutline className='personIcon' /> */}

                            <span id="rwd-nav-footer-span">{userFullname}</span>
                        </div>
                    ) : (
                        <div
                            className="rwd-nav-footer d-flex align-items-center border-top mx-3 py-3"
                            onClick={handleIsLogin}
                        >
                            {/* <PersonOutline className='personIcon' /> */}

                            <span id="rwd-nav-footer-span">{t('navMenu:loginOrRegister')}</span>
                        </div>
                    )}
                    {auth?.accessToken && (
                        <div
                            // 關閉RwdNav
                            onClick={() => setRwdNavShow(false)}
                        >
                            <div className="rwd-nav-page" onClick={() => navigate('/baseinfo')}>
                                {t('basic_information')}
                            </div>
                            <div className="rwd-nav-page" onClick={() => navigate('/pwdreset')}>
                                {t('change_password')}
                            </div>
                            <div className="rwd-nav-page" onClick={() => navigate('/product')}>
                                {t('my_product')}
                            </div>
                            <div
                                className="rwd-nav-page"
                                onClick={() => navigate('/member/productvip')}
                            >
                                {t('user_family')}
                            </div>
                            <div className="rwd-nav-page" onClick={() => navigate('/orders')}>
                                {t('orders')}
                            </div>
                            {/* <div className='rwd-nav-page' onClick={() => navigate('/accountDelete')}>
                                刪除帳號
                            </div> */}
                            <div className="rwd-nav-page" onClick={handleLogout}>
                                {t('logout')}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default NavMenu;
